import { IGetMetricDataPointsByIdsParams } from '../types/IGetMetricDataPointsByIdsParams';
import { IMetricDataList } from '../types/IMetricDataList';
import { Request } from './Request';

export type GetMetricDataPointsByIdsParams = IGetMetricDataPointsByIdsParams;

export class GetMetricDataPointsByIdsRequest extends Request<GetMetricDataPointsByIdsParams, IMetricDataList> {
  constructor(params: GetMetricDataPointsByIdsParams) {
    super('getMetricDataPointsByIds', params);
  }
}
